/**
 * Schema definition for Property Rear Form
 * This schema defines all fields, their types, and organization
 */

import { BuiltInFormSchema } from '../types/builtInFormSchema';

export const propertyRearFormSchema: BuiltInFormSchema = {
  formId: 'property_rear',
  formTitle: 'Property Rear',
  
  sections: [
    // Section 1: Rear Elevation
    {
      id: 'rear_elevation',
      title: 'Rear Elevation',
      fields: [
        {
          id: 'rearElevationImage',
          type: 'photo',
          label: 'Rear Elevation',
          required: true,
          maxPhotos: 999
        },
        {
          id: 'roofTypeEvidenceImages',
          type: 'photo',
          label: 'Roof Type Evidence',
          required: true,
          maxPhotos: 999,
          helpText: 'Rear elevation roof images'
        }
      ]
    },
    
    // Section 2: Backyard
    {
      id: 'backyard',
      title: 'Backyard',
      fields: [
        {
          id: 'hasBackyard',
          type: 'boolean',
          label: 'Does the property have a backyard?',
          required: true,
          style: 'yes-no'
        },
        {
          id: 'rearBackyardImages',
          type: 'photo',
          label: 'Backyard Images',
          maxPhotos: 999,
          conditionalOn: {
            fieldId: 'hasBackyard',
            value: true
          }
        }
      ]
    },
    
    // Section 3: Guttering & Drainage
    {
      id: 'guttering_rear',
      title: 'Guttering & Drainage',
      fields: [
        {
          id: 'gutteringDrainageImages',
          type: 'photo',
          label: 'Guttering & Drainage Photos (Rear)',
          maxPhotos: 999
        }
      ]
    },
    
    // Section 4: External Wall Details (Rear)
    {
      id: 'wall_rear',
      title: 'External Wall Details (Rear)',
      fields: [
        {
          id: 'externalWallType',
          type: 'dropdown',
          label: 'External Wall Type',
          required: true,
          options: [
            { value: '', label: 'Select Wall Type' },
            { value: 'brick', label: 'Brick' },
            { value: 'stone', label: 'Stone' },
            { value: 'concrete', label: 'Concrete' },
            { value: 'timber', label: 'Timber Frame' },
            { value: 'render', label: 'Render' },
            { value: 'other', label: 'Other' }
          ]
        },
        {
          id: 'externalWallCondition',
          type: 'dropdown',
          label: 'External Wall Condition',
          required: true,
          options: [
            { value: '', label: 'Select Condition' },
            { value: 'excellent', label: 'Excellent' },
            { value: 'good', label: 'Good' },
            { value: 'fair', label: 'Fair' },
            { value: 'poor', label: 'Poor' },
            { value: 'very_poor', label: 'Very Poor' }
          ]
        },
        {
          id: 'wallTypeEvidenceImage',
          type: 'photo',
          label: 'Wall Type Evidence',
          required: true,
          maxPhotos: 999
        },
        {
          id: 'isWallInsulated',
          type: 'boolean',
          label: 'Is the Wall Insulated?',
          required: true,
          style: 'yes-no-na'
        },
        {
          id: 'hasWallDefects',
          type: 'boolean',
          label: 'Additional visible wall defects?',
          style: 'yes-no'
        },
        {
          id: 'wallDefectImages',
          type: 'photo',
          label: 'Images of Wall Defects (Rear)',
          required: true,
          maxPhotos: 999,
          conditionalOn: {
            fieldId: 'hasWallDefects',
            value: true
          }
        }
      ]
    },
    
    // Section 5: Additional Notes
    {
      id: 'notes_rear',
      title: 'Additional Notes',
      fields: [
        {
          id: 'additionalNotes',
          type: 'textarea',
          label: 'Additional Notes for Property Rear',
          rows: 3,
          placeholder: 'Enter any other relevant details for the rear of the property...'
        }
      ]
    }
  ],
  
  defaultSectionOrder: [
    'rear_elevation',
    'backyard',
    'guttering_rear',
    'wall_rear',
    'notes_rear'
  ]
};
